import { render, staticRenderFns } from "./MediaProcessor.vue?vue&type=template&id=44f168ef&scoped=true"
import script from "./MediaProcessor.vue?vue&type=script&lang=js"
export * from "./MediaProcessor.vue?vue&type=script&lang=js"
import style0 from "./MediaProcessor.vue?vue&type=style&index=0&id=44f168ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f168ef",
  null
  
)

export default component.exports